export default __webpack_public_path__ + "static/media/bestpricembl.d175bc61.png";